export const WS_CONSTANTS = {
    WEBSERVICE_WORKSPACE_TYPE: "ws",
    HTTP_METHODS: ["GET", "POST", "PUT", "HEAD", "PATCH", "DELETE"],
    NON_BODY_HTTP_METHODS: ["GET", "HEAD"],
    PRIMITIVE_DATA_TYPES: ["number", "integer", "string", "boolean", "file"],
    OPERATION_NAME_KEY: "x-WM-METHOD_NAME",
    CONTENT_TYPES: {
        FORM_URL_ENCODED: "application/x-www-form-urlencoded",
        MULTIPART_FORMDATA: "multipart/form-data",
        OCTET_STREAM: "application/octet-stream"
    },
    CONTROLLER_NAMES: {
        QUERY_CONTROLLER: "QueryExecutionController",
        PROCEDURE_CONTROLLER: "ProcedureExecutionController"
    },
    HTTP_STATUS_CODE: {
        CORS_FAILURE: -1,
        UNAUTHORIZED: 401,
        FORBIDDEN: 403
    },
    HTTP_STATUS_CODE_MESSAGES: {
        '401': "Requested resource requires authentication",
        '-1': "Possible CORS Failure, try disabling Same-Origin Policy on the browser."
    }
}